import type { Point } from '@ikegps/core-api';
import { runInAction } from 'mobx';
import { IkeId } from '../../id';
import { CollectionModelDrawableLine } from '../../model/collection/drawable/line.drawable';
import type { IkeDraw } from '../draw';
import { LabelSVGDraw } from '../drawable/label.draw.svg';
import { movePoint } from '../util';

export interface LineCreateEvent {
	drawableId?: string;
	center: Point;
	$event: MouseEvent;
}

const START_DELTA = { x: -100, y: 0 };
const END_DELTA = { x: 100, y: 0 };
const LABEL_DELTA = { x: 150, y: 150 };

function getLabelPoint(dc: IkeDraw, center: Point): Point {
	const uiScale = dc.state.scale;

	return movePoint(center, LABEL_DELTA, dc.capture.resolution, {
		width: LabelSVGDraw.Size.width * uiScale,
		height: LabelSVGDraw.height(1) * uiScale,
	});
}

function createLineAt(dc: IkeDraw, center: Point) {
	const labelPoint = getLabelPoint(dc, center);
	const startPoint = movePoint(center, START_DELTA, dc.capture.resolution);
	const endPoint = movePoint(center, END_DELTA, dc.capture.resolution);

	const { start } = CollectionModelDrawableLine.createWithLinePointsAndLabel(
		dc.drawState,
		IkeId.generate(),
		startPoint,
		endPoint,
		labelPoint
	);

	dc.state.setSelected(start.id, null);
}

export function drawableLineCreateBinding(dc: IkeDraw, evt: LineCreateEvent) {
	if (evt.drawableId == null) {
		runInAction(() => createLineAt(dc, evt.center));
		return;
	}

	if (evt.$event != null) {
		evt.$event.preventDefault();
	}
}
